export const escapeCsvField = value => {
  if (value === undefined || value === null) return ''
  return String(value).replace(/"/g, '""')
}

export const wrapCsvField = value => `"${escapeCsvField(value)}"`

export const toSafeFilenamePart = value =>
  String(value || 'venue')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const buildCsvString = rows => {
  const csv = rows.map(row => row.map(wrapCsvField).join(',')).join('\n')
  // ✅ Prepend UTF-8 BOM
  return '\uFEFF' + csv
}
